// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "select.is-danger[data-v-4effd920]{border-color:#ff3860}.field[data-v-4effd920]{padding:.5rem 1rem;width:100%}.flex-button[data-v-4effd920]{flex-shrink:0}.address[data-v-4effd920]{margin-top:.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
